// src/components/Team/InvitUser/ResendInviteCard.jsx
import React, { useContext, useMemo, useState } from "react";
import { MdSend, MdCancel, MdClose } from "react-icons/md";
import { useTranslation } from "react-i18next";

import NavContext from "../../../context/NavContext";
import Axios from "../../../_services/caller.service";

import styles from "./ResendInviteCard.module.scss";
// import Button from "../../UiComponents/Button";
import Loader from "../../UiComponents/loader/Loader";
import Success from "../../UiComponents/sucess/Success";
import { PermissionGate } from "../../superAdmin/managePermissions/PermissionGate";

export default function ResendInviteCard({
  invit,
  inviteWaiting, // optionnel si tu en as encore besoin ailleurs
  setNewInvite,
  newInvite,
  dateInvitation,
  dateExpiration,
}) {
  const { ownerId, ownerProfile } = useContext(NavContext);
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(""); // "resent" | "canceled" | ""
  const [confirm, setConfirm] = useState(null); // "resend" | "cancel" | null

  const inviteName = invit?.display_name || "—";
  const inviteEmail = invit?.email || "—";
  const hashId = invit?.hash;

  const senderOwner = ownerProfile?.display_name || "";
  const emailOwner = ownerProfile?.user_email || "";

  // si ton API a besoin de name + lastname, on fait un split simple :
  const { name, lastName } = useMemo(() => {
    const dn = (invit?.display_name || "").trim();
    if (!dn) return { name: "", lastName: "" };
    const parts = dn.split(" ");
    if (parts.length === 1) return { name: "", lastName: parts[0] };
    return { name: parts.slice(0, -1).join(" "), lastName: parts.slice(-1)[0] };
  }, [invit]);

  const closeConfirm = () => setConfirm(null);

  const handleAction = async (type) => {
    if (!ownerId || !inviteEmail) return;

    setLoading(true);
    try {
      if (type === "cancel") {
        await Axios.delete(`/deleteInviteList/${inviteEmail}/${hashId}`);
        setToast("canceled");
      }

      if (type === "resend") {
        // 1) renvoie l’email d’invitation
        const res = await Axios.post(`/inviteUser/${ownerId}`, {
          data: { name, lastName, email: inviteEmail, ownerId, senderOwner, emailOwner },
        });

        const linkSend = res?.data?.data?.link;

        // 2) (optionnel) update inviteList en base
        // -> ici tu peux garder ton update si c'est nécessaire à ton back
        // -> sinon tu peux le supprimer complètement
        await Axios.put(`/updateInviteList/${ownerId}`, {
          data: {
            hash: Math.random(), // ou garde invit.hash si tu veux conserver l’id
            ownerId,
            email: inviteEmail,
            lastName: inviteName,
            name: "",
            linkSend,
          },
        });

        setToast("resent");
      }

      // refresh liste
      setNewInvite?.(newInvite + 1);

      // hide confirm + toast
      setConfirm(null);
      setTimeout(() => setToast(""), 2200);
    } catch (e) {
      console.log(e);
      setConfirm(null);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.card}>
      {/* INFOS */}
      <div className={styles.info}>
        <div className={styles.line1}>
          <div className={styles.name} title={inviteName}>
            {inviteName}
          </div>
          <div className={styles.email} title={inviteEmail}>
            {inviteEmail}
          </div>
        </div>

        <div className={styles.line2}>
          <div className={styles.meta}>
            <span className={styles.label}>{t("invite.invitation_label")}</span>
            <span className={styles.value}>{dateInvitation}</span>
          </div>

          <div className={styles.meta}>
            <span className={styles.label}>{t("invite.expiration_label")}</span>
            <span className={styles.value}>{dateExpiration}</span>
          </div>
        </div>
      </div>

      {/* ACTIONS */}
      <div className={styles.actions}>
        <button
          type="button"
          className={styles.btnDanger}
          onClick={() => setConfirm("cancel")}
        >
          <MdCancel style={{ marginRight: 6 }} /> {t("common.cancel")}
        </button>

        <button
          type="button"
          className={styles.btnSuccess}
          onClick={() => setConfirm("resend")}
        >
          <MdSend style={{ marginRight: 6 }} /> {t("invite.resend")}
        </button>
      </div>

      {/* CONFIRM OVERLAY */}
      {confirm && (
        <div className={styles.overlay} role="dialog" aria-modal="true">
          <div className={styles.overlayBox}>
            <button className={`${styles.close} has-tooltip`} onClick={closeConfirm} aria-label={t("common.close")}>
              <MdClose />
            </button>

            <div className={styles.overlayTitle}>
              {confirm === "resend" ? t("invite.resend_invitation_question") : t("invite.cancel_invitation_question")}
            </div>

            <div className={styles.overlayText}>
              {confirm === "resend"
                ? t("invite.resend_email_text")
                : t("invite.cancel_email_text")}
            </div>

            <div className={styles.overlayActions}>
              <button
                type="button"
                className={styles.btnDanger}
                onClick={closeConfirm}
              >
                <MdCancel style={{ marginRight: 6 }} /> {t("common.back")}
              </button>
              <button
                type="button"
                className={confirm === "resend" ? styles.btnSuccess : styles.btnDanger}
                onClick={() => handleAction(confirm)}
              >
                {confirm === "resend" ? (
                  <MdSend style={{ marginRight: 6 }} />
                ) : (
                  <MdCancel style={{ marginRight: 6 }} />
                )}
                {confirm === "resend" ? t("invite.confirm_send") : t("invite.confirm_cancel")}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* TOAST */}
      {toast === "resent" && (
        <div className={styles.toast}>
          <Success success={t("invite.invitation_resent")} />
        </div>
      )}
      {toast === "canceled" && (
        <div className={styles.toast}>
          <Success success={t("invite.invitation_canceled")} />
        </div>
      )}

      {loading && <Loader />}
    </div>
  );
}